export default "__VITE_ASSET__5c2be26d__"